import { Shimmer, ShimmerElementType, Stack } from '@fluentui/react';
import React from 'react';

/** Placeholder rows while campus/area directory data is loading (dashboard, area panel). */
const AreaDirectorySkeleton: React.FC<{ compact?: boolean }> = ({ compact }) => {
    const cardCount = compact ? 4 : 6;
    return (
        <Stack
            horizontal
            wrap
            tokens={{ childrenGap: 16 }}
            horizontalAlign="start"
            verticalAlign="start"
            style={{ width: '100%', padding: compact ? '8px 0' : '16px 0' }}
            aria-busy
            aria-label="Loading areas"
        >
            {Array.from({ length: cardCount }).map((_, i) => (
                <Stack key={i} tokens={{ childrenGap: 8 }} style={{ width: compact ? 300 : 360 }}>
                    <Shimmer width="100%" shimmerElements={[{ type: ShimmerElementType.line, height: 200, width: '100%' }]} />
                </Stack>
            ))}
        </Stack>
    );
};

export default AreaDirectorySkeleton;
